import { GapDialogProps } from 'reusable/gap-dialog/GapDialog'
import { messageActions } from './message-actions'

type Without<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>

type messageErrorProps = Without<GapDialogProps, 'primary' | 'secondary' | 'cancel' | 'children' | 'title'>
export async function messageError(
   children: GapDialogProps['children'],
   title?: GapDialogProps['title'],
   options?: messageErrorProps) {
   if (title === undefined || title === null) {
      title = 'Error'
   }
   return messageActions({
      title: title,
      children: children,
      primary: {
         name: 'Ok'
      },
      ...options,
   })
}
